import React, {Suspense} from 'react';
import HomeMileageInnerContentsKr, {
  HomeMileageInnerContentsOdometerError,
} from '@di-shared/features/home/kr/benefit/HomeMileageInnerContents.kr';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {ErrorBoundary} from 'react-error-boundary';
import HomeMileageEarningNoticeKr from '@di-shared/features/home/kr/benefit/HomeMileageEarningNotice.kr';
import {emitEventLog} from '@di-shared/features/analytics';
import ImageSelector from '@di-shared/features/common/ImageSelector';
import useOdometer from '@di-shared/features/mileage/useOdometer';

interface HomeMileageKrProps {
  vin: string;

  onClick(): void;
}

function HomeMileageKr({vin, onClick}: HomeMileageKrProps) {
  const {t} = useInferableTranslation();
  const {odometer} = useOdometer(vin);
  return (
    <>
      <section className="section section_eco_mileage">
        <div className="section_container">
          <div className="section_container_header">
            <div className="container_header_title">
              <h3 className="label_medium_b">{t('T10122')}</h3>
              <strong
                className="title_xxsmall"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T10123')}
              </strong>
            </div>
            <div className="container_header_imgbox">
              <ImageSelector
                alt="eco_mileage_img"
                kiaLightSrc={() => import('@di-shared/assets/img/home/eco_mileage_car.png')}
                kiaDarkSrc={() => import('@di-shared/assets/img/home/eco_mileage_car.png')}
                hyundaiLightSrc={() => import('@di-shared/assets/img/home/hyundai/eco_mileage_car.png')}
                hyundaiDarkSrc={() => import('@di-shared/assets/img/home/hyundai/eco_mileage_car.png')}
                genesisLightSrc={() => import('@di-shared/assets/img/home/genesis/eco_mileage_car.png')}
                genesisDarkSrc={() => import('@di-shared/assets/img/home/genesis/eco_mileage_car.png')}
              />
            </div>
          </div>
          {odometer ? <HomeMileageInnerContentsKr vin={vin} /> : <HomeMileageInnerContentsOdometerError />}
          <button
            type="button"
            className="btn btn_large btn_filled btn_full"
            onClick={() => {
              emitEventLog({
                event: 'mileage_management',
                interaction_type: 'check mileage',
                click_text: t('T10131'),
                click_location: 'body',
              });
              onClick();
            }}
          >
            {t('T10131')}
          </button>
        </div>
      </section>
      <ErrorBoundary fallback={<></>}>
        <Suspense fallback={<></>}>
          <HomeMileageEarningNoticeKr vin={vin} />
        </Suspense>
      </ErrorBoundary>
    </>
  );
}

export default HomeMileageKr;

export function HomeMileageLoading() {
  const {t} = useInferableTranslation();
  return (
    <section className="section section_eco_mileage">
      <div className="section_container">
        <div className="section_container_header skeleton">
          <div className="container_header_title">
            <h3 className="label_medium_b">{t('T10122')}</h3>
            <strong
              className="title_xxsmall"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T10123')}
            </strong>
          </div>
          <div className="container_header_imgbox">
            <ImageSelector
              alt="eco_mileage_img"
              kiaLightSrc={() => import('@di-shared/assets/img/home/eco_mileage_car.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/home/eco_mileage_car.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/home/hyundai/eco_mileage_car.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/home/hyundai/eco_mileage_car.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/home/genesis/eco_mileage_car.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/home/genesis/eco_mileage_car.png')}
            />
          </div>
        </div>
        <ul className="eco_state_list">
          <li className="eco_state_item skeleton">
            <strong className="eco_state_title">{t('T10124')}</strong>
            <p className="eco_state_desc">{t('T10125_$mileage', {mileage: 0})}</p>
            <div className="badge_box">
              <span className="badge badge_basic_container badge_20px">{t('T10126')}</span>
            </div>
          </li>
          <li className="eco_state_item skeleton">
            <strong className="eco_state_title">{t('T10127')}</strong>
            <p className="eco_state_desc">{t('T10125_$mileage', {mileage: 0})}</p>
            <div className="badge_box">
              <span className="badge badge_container_red badge_20px">{t('T10126')}</span>
            </div>
          </li>
        </ul>
        <button
          type="button"
          className="btn btn_large btn_full disabled skeleton"
          disabled
        >
          {t('T10131')}
        </button>
      </div>
    </section>
  );
}
